import config from 'config';
import React from 'react';
import styles from './AppInfo.module.scss';

export const AppInfo = () => {
  return <div className={styles.appInfo}> v{config.version}</div>;
};
